import { FlexColumn } from "@/components/Flex";
import { iconSizes } from "@/utils/iconProps";

const LevelsIcon = ({
    level,
    customTextNode,
    size = iconSizes.MD_M,
    ...props
}: { level?: string | number; customTextNode?: React.ReactNode; size?: number } & React.SVGProps<SVGSVGElement>) => (
    <FlexColumn style={{ position: "relative" }}>
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            data-testid="auto-id-e235018e-1166-49c8-9d1d-7c99f138df1e">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.9936 0.677492C12.8268 2.26076 10.5479 3.66886 8.91217 4.43512C6.50413 5.56309 3.60975 6.40891 0.959029 6.7591C0.611852 6.80501 0.250714 6.85849 0.156549 6.87803C-0.0147001 6.91354 -0.0147001 6.91354 0.0147078 13.244C0.0352042 17.6458 0.0712958 19.7555 0.133305 20.1688C0.552591 22.9655 1.39413 25.5485 2.58983 27.7088C5.16674 32.3646 9.24196 35.8051 14.2339 37.5394C15.7725 38.0739 15.8923 38.0894 16.6963 37.8587C20.044 36.8981 23.2063 35.0219 25.7263 32.501C29.0455 29.1808 31.0489 25.1043 31.787 20.1688C31.8487 19.7565 31.885 17.6353 31.9054 13.244C31.9348 6.91354 31.9348 6.91354 31.7635 6.87803C31.6694 6.85849 31.3082 6.80501 30.9611 6.7591C29.0555 6.50734 26.6524 5.90354 24.9136 5.23957C22.3382 4.25616 19.8307 2.81575 16.784 0.569628C16.359 0.256362 15.9909 0 15.9661 0C15.9412 0 15.5036 0.304871 14.9936 0.677492Z"
                fill="#6745AE"
                data-testid="auto-id-6212fb18-2d34-4c0d-bc31-afeb32c4f7a4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1711 4.04622C13.3964 5.33183 11.5298 6.47521 10.1901 7.09741C8.21782 8.01332 5.84718 8.70013 3.67612 8.98448C3.39176 9.02176 3.09597 9.06519 3.01885 9.08105C2.87858 9.10989 2.87858 9.10989 2.90267 14.2502C2.91946 17.8245 2.94902 19.5376 2.99981 19.8731C3.34322 22.1441 4.03249 24.2415 5.01182 25.9957C7.12243 29.7761 10.4602 32.5698 14.5489 33.9781C15.809 34.4121 15.9072 34.4247 16.5657 34.2374C19.3076 33.4574 21.8977 31.9339 23.9617 29.8869C26.6803 27.1909 28.3212 23.8808 28.9257 19.8731C28.9762 19.5384 29.0059 17.816 29.0226 14.2502C29.0467 9.10989 29.0467 9.10989 28.9065 9.08105C28.8293 9.06519 28.5336 9.02176 28.2492 8.98448C26.6884 8.78005 24.7202 8.28977 23.2961 7.75062C21.1867 6.9521 19.1329 5.78248 16.6375 3.95863C16.2894 3.70426 15.988 3.49609 15.9676 3.49609C15.9472 3.49609 15.5888 3.74365 15.1711 4.04622Z"
                fill="#976EEE"
                data-testid="auto-id-f1f9c0bb-433b-4e72-9c6a-c55daac9e83b"
            />
            {level && (
                <text
                    x="50%"
                    y="55%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontWeight="700"
                    fill="#fff"
                    fontSize={level.toString().length > 2 ? "1em" : level.toString().length > 2 ? "1.05em" : "1.1em"}
                    data-testid="auto-id-6028160a-e41f-4414-8fe6-8e774df53eb4">
                    {level}
                </text>
            )}
        </svg>
        {customTextNode}
    </FlexColumn>
);

export default LevelsIcon;
